/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React, { useCallback, useState } from "react";
import { Drawer } from "antd";
import { useSelector } from "react-redux";
import CloseIcon from "../../../Common/Svgs/CloseIcon";
import SortIcon from "../../../Common/Svgs/SortIcon";

const DetailDrawer = ({ visible, onCancel }) => {
  const { selectedService } = useSelector((state) => state.services);

  const [sort, setSort] = useState({ column: "itemCode", order: "asc" });

  const getData = useCallback(() => {
    if (!selectedService?.inventoryItems?.length) return [];

    const data = [...selectedService.inventoryItems].sort((a, b) => {
      const valA = a?.[sort.column];
      const valB = b?.[sort.column];

      // null or undefined values
      if (valA == null) return 1;
      if (valB == null) return -1;

      // number sort
      if (typeof valA === "number" && typeof valB === "number") {
        return sort.order === "asc" ? valA - valB : valB - valA;
      }

      // string sort
      return sort.order === "asc"
        ? String(valA).localeCompare(String(valB))
        : String(valB).localeCompare(String(valA));
    });

    return data;
  }, [sort, selectedService]);

  const handleSortClick = (column) => {
    setSort((prev) => ({
      column,
      order:
        prev.column === column
          ? prev.order === "asc"
            ? "desc"
            : "asc"
          : "asc",
    }));
  };

  if (!visible) return null;

  return (
    <Drawer
      width={560}
      placement="right"
      closable={false}
      zIndex={2000}
      maskStyle={{ background: "transparent" }}
      open={visible}
      className="rounded-tl-xl"
      onClose={onCancel}
    >
      <div className="">
        <div className="p-6 flex items-center justify-between">
          <div>
            <p className="font-poppins font-medium text-base text-black">
              Maintenance Details{" "}
            </p>

            <p className="font-poppins font-medium text-sm text-black">
              {selectedService ? ` Repair-0${selectedService?.id}` : ""}
            </p>
          </div>

          <button type="button">
            <CloseIcon
              className="w-5 h-5 cursor-pointer stroke-dark-grey-text"
              onClick={onCancel}
            />
          </button>
        </div>

        {/* column header */}
        <div className="flex items-center bg-background border-b-[0.5px] border-light-grey">
          <div className="flex items-center py-2.5 px-6 gap-x-1 w-[33.3%]">
            <p className="font-aileron font-normal text-10 leading-[100%] text-dark-gray">
              Inventory Item
            </p>

            <div role="button" onClick={() => handleSortClick("itemCode")}>
              <SortIcon />
            </div>
          </div>

          <div className="flex items-center py-2.5 px-6 gap-x-1 w-[33.3%]">
            <p className="font-aileron font-normal text-10 leading-[100%] text-dark-gray">
              SKU ID
            </p>

            <div role="button" onClick={() => handleSortClick("skuId")}>
              <SortIcon />
            </div>
          </div>

          <div className="flex items-center py-2.5 px-6 gap-x-1 w-[33.3%]">
            <p className="font-aileron font-normal text-10 leading-[100%] text-dark-gray">
              Repair Cost
            </p>

            <div role="button" onClick={() => handleSortClick("totalValue")}>
              <SortIcon />
            </div>
          </div>
        </div>

        {/* row items */}
        {selectedService?.inventoryItems?.length ? (
          getData().map((d, index) => {
            return (
              <div
                key={index}
                className={`flex items-center bg-white ${
                  selectedService?.inventoryItems?.length !== index + 1
                    ? "border-b-[0.5px] border-light-grey"
                    : ""
                }`}
              >
                <p className="w-[33.3%] py-[15px] px-6 font-aileron font-semibold text-xs leading-[100%] text-dark-gray capitalize">
                  {d?.itemCode}
                </p>

                {/* no SKU ID available from ERP */}
                <p className="w-[33.3%] py-[15px] px-6 font-aileron font-semibold text-xs leading-[100%] text-dark-gray">
                  {d?.skuId || "--"}
                </p>

                <p className="w-[33.3%] py-[15px] px-6 font-aileron font-semibold text-xs leading-[100%] text-dark-gray">
                  {d?.totalValue} KSH
                </p>
              </div>
            );
          })
        ) : (
          <p className="my-8 font-aileron text-sm text-black text-center">
            No inventory items used
          </p>
        )}

        {/* total cost */}
        <div className="flex items-center bg-background py-[15px] px-6 border-b-[0.5px] border-light-grey">
          <p className="w-[73%] font-aileron font-semibold text-xs leading-[100%] text-black">
            Total Maintenance Cost
          </p>

          <p className="w-[27%] font-aileron font-semibold text-xs leading-[100%] text-black">
            {selectedService?.totalCost} KSH
          </p>
        </div>

        <div className="mt-4 px-6">
          <p className="font-aileron font-semibold text-xs leading-[100%] text-black">
            Actions Performed
          </p>

          <div className="mt-4 p-4 rounded-lg border border-light-grey">
            <p className="font-aileron font-normal text-xs leading-4 text-black">
              {selectedService?.reportDescription || "--"}
            </p>
          </div>
        </div>

        <div className="mt-4 px-6">
          <p className="font-aileron font-semibold text-xs leading-[100%] text-black">
            Issue Description
          </p>

          <div className="mt-4 p-4 rounded-lg border border-light-grey">
            <p className="font-aileron font-normal text-xs leading-4 text-black">
              {selectedService?.description || "--"}
            </p>
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default DetailDrawer;
